import React from "react";
import { FetchHTML } from "./FetchHTML";
import { CurrencyContext } from "../Context/Currency";
import { RenderContext } from "../Context/Ssr";
import { CatalogContext } from "../Translator/withTranslation";
import { LocaleContext } from "../Context/Locale";


const IndexTextComponent = (props) => {
    return(
            props.content != '' &&
            <div
                className={(props.className ? props.className : '')}
                style={(props.style ? props.style : {})}>
                {props.url ?
                <FetchHTML url={this.props.url} />
                :
                <div dangerouslySetInnerHTML={{__html: props.content}} />
                }
            </div>
        );
}

export const IndexText = (initialProps, context) => {
    return (
        <LocaleContext.Provider value={initialProps.locale}>
            <CatalogContext.Provider value={initialProps.catalog} >
                <RenderContext.Provider value={context}>
                    <CurrencyContext.Provider value={initialProps.currency}>
                        <IndexTextComponent {...initialProps} />
                    </CurrencyContext.Provider>
                </RenderContext.Provider>
            </CatalogContext.Provider>
        </LocaleContext.Provider>
    );
};